import TestsReducer from '../features/redux/reducers/testsReducer'
import JobsReducer from '../features/redux/reducers/jobsReducer'
import ReportsReducer from '../features/redux/reducers/reportsReducer'
import authReducer from '../features/redux/reducers/authReducer'
import ConfigReducer from '../features/redux/reducers/configReducer'
import ProcessorsReducer from '../features/redux/reducers/processorsReducer'
import WebhooksReducer from '../features/redux/reducers/webhooksReducer'

export default {
    TestsReducer,
    JobsReducer,
    ReportsReducer,
    authReducer,
    ConfigReducer,
    ProcessorsReducer,
    WebhooksReducer
};
